/** a function that believes in nothing, Lebowski, NOTHING */
var noop = function noop() {};

export { noop };
